<template>
    <rkm-layout-body title="Lista de exame">
        <template v-slot:actions>
            <rkm-button
                @click="$refs.Modal.open()"
                authorize="store-parametrizacao-exame"
                color="info"
            >
                Atribuição de parâmetro por grupo
            </rkm-button>

            <rkm-button
                @click="$router.push({ name: 'parametrizacao-exame-create' })"
                color="primary"
                authorize="store-parametrizacao-exame"
            >
                Cadastrar exame
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>

        <Modal ref="Modal" />
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/parametrizacao/exame/List'
import Modal from '@/components/parametrizacao/exame/Modal'

export default {
    components: {
        List,
        Modal,
    },
}
</script>